var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"my-10",attrs:{"justify":"space-around"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('terms-and-conditions')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }